
import { Injectable } from '@angular/core';
import { SiriusServiceBase, SiriusDataService } from '@ibtech/sirius-angular-service'
import { OldProcessRequest } from '../shared/models/process.model';

@Injectable()
export class InnerMenuOldProcessService extends SiriusServiceBase {
    constructor() {
        super();
    }
    getUserOldProcess(dataService: SiriusDataService, oldProcessRequest: OldProcessRequest) {
        return dataService.post("GetUserOldProcess", oldProcessRequest);
    }
}
